module.exports = __webpack_public_path__ + "img/feedback_wrong_discount_dark.ae3c9dc9.gif";